//@flow

import React, {useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {
  IconButton,
  Grid,
  Typography,
  FormControlLabel,
  Radio,
  InputAdornment,
  Hidden,
  Icon,
  Checkbox,
  Snackbar,
} from '@material-ui/core';

import {useForm} from 'react-hook-form';
import {useHistory, useParams} from 'react-router-dom';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {usePage} from '../../../../page/utils';
// import {ArrowBack} from '@material-ui/icons';
import {CancelOutlined, PublishRounded} from '@material-ui/icons';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';

import SnackBar from '../../../../../elements/SnackBar/SnackBar';

import {colors} from '../../../../../assets/styles/colors';
import addImage from '../../../../../assets/img/addImage.png';

import CustomSelect from '../../../../../elements/CustomSelect/CustomSelect';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import Collapsible from '../../../../../elements/Collapsible/Collapsible';
import LoadingSpinner from '../../../../../elements/LoadingSpinner/LoadingSpinner';
import ModalSelectItems from '../../../coupons/components/ModalSelectItems/ModalSelectItems';

import {commaFormat} from '../../../../../utils/number';
import {getImageUrl} from '../../../../../utils/image_provider';
import {
  useFeatureSpec,
  useIsFeatureInTier,
} from '../../../../../utils/component';

import type {
  Currency,
  PromotionType,
  Pagination,
  Product,
  Category,
  SinglePromotion,
} from '../../../../../entities';

import {Alert} from '@material-ui/lab';
import AlertActivePromotion from '../AlertActivePromotion/AlertActivePromotion';
import CropModal from '../../../../../elements/CropModal';

import type {PromotionRequest} from '../../api';
import type {ImageToCrop} from '../../../../../elements/CropModal';

type Props = {
  isFetchingCoupon?: boolean,
  isSaving?: boolean,
  promotion?: SinglePromotion,
  isFetchingPromotion?: boolean,
  createPromotionSuccess?: boolean,
  updatePromotionSuccess?: boolean,
  error?: string,
  currency?: Currency,
  productsFilter?: Product[],
  categoriesFilter?: Category[],
  createPromotion: ({promotionRequest: PromotionRequest}) => void,
  updatePromotion: ({
    promotionRequest: PromotionRequest,
    promotionId: string,
  }) => void,
  fetchPromotion: ({promotionId: string}) => void,
  fetchProducts: ({
    queryFilter?: {[key: string]: string | any},
  }) => void,
  fetchCategoriesSearch: ({
    queryFilter?: {[key: string]: string | any},
  }) => void,
  isFetchingProducts?: boolean,
  isFetchingCategories?: boolean,
  paginationProducts?: Pagination,
  paginationCategories?: Pagination,
  resetProductsFilter: () => void,
  resetCategoriesFilter: () => void,
  resetPromotion: () => void,
  promotions?: SinglePromotion[],
};

const useStyles = makeStyles(theme => ({
  promotionWrap: {},
  grayText: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#55556D',
  },
  gridFormulario: {
    padding: theme.spacing(1),
  },
  headerWrapper: {
    maxWidth: 1300,
    padding: theme.spacing(0, 4, 2, 0),
    background: '#f8f9fb',
    display: 'flex',
    justifyContent: 'space-between',
  },
  backButton: {
    background: 'white',
    padding: '4px',
    margin: '0 16px 0 0',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  wrapperItem: {
    width: '100%',
  },
  item: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  nameProduct: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    color: colors.grey800,
    margin: 'auto 8px',
  },
  imageItem: {
    borderRadius: '8px',
  },
  containerSaveButton: {
    [theme.breakpoints.down('sm')]: {
      zIndex: 1,
      position: 'fixed',
      left: 0,
      bottom: 64,
      height: 108,
      width: '100%',
      fontSize: '1.125rem',
    },
  },
  cardSaveButton: {
    background: '#FFFFFF',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  saveButton: {
    marginBottom: theme.spacing(1),
    borderRadius: '32px',
  },
  title: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 600,
    color: 'black',
  },
  cardWrap: {
    margin: '16px 0',
    background: '#FFFFFF',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    padding: '24px',
  },
  maxWidth: {
    maxWidth: '600px',
  },
  labelText: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: colors.grey900,
    paddingBottom: '16px',
  },
  commentText: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.grey700,
    padding: '8px 0 24px',
  },
  typesWrap: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '24px',
  },
  radioButton: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    color: colors.grey800,
  },
  radioButtonSelected: {
    fontWeight: 500,
    color: `${colors.grey900} !important`,
  },
  informationLabel: {
    background: '#EEE5FF',
    borderRadius: '8px',
    color: '#7B39FF',
    maxWidth: 196,
    textAlign: 'center',
    padding: 8,
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '10px',
    lineHeight: '10px',
    marginTop: '12px',
    marginBottom: '12px',
  },
  textError: {
    color: '#f44336',
    fontSize: '0.75rem',
    marginTop: '3px',
    textAlign: 'left',
    fontWeight: 400,
    lineHeight: '1.66',
  },
  descriptionWrapper: {
    paddingInlineStart: '20px',
  },
  description: {
    color: '#55556D',
    fontSize: '14px',
    padding: '0!important',
  },
  descriptionSmall: {
    color: '#55556D',
    fontSize: '12px',
    padding: '0!important',
  },
  gridBuyBring: {
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
    },
  },
  switch: {
    marginLeft: '16px',
  },
  labelSwitch: {},
  switchTitle: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.grey800,
  },
  switchBody: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.grey700,
  },
  textRequirement: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.grey800,
  },
  textRequirementSelected: {
    color: colors.grey900,
  },
  textInput: {
    fontSize: '16px',
    color: '#3A3A49',
  },
  addImage: {
    fontSize: '18px',
    textAlign: 'center',
    fontWeight: 600,
  },
  textDescription: {
    padding: '0!important',
  },
  headerRaw: {
    background: '#F4F4F6',
    borderRadius: '4px',
    padding: theme.spacing(3, 1),
  },
  headerRawPrice: {
    fontSize: '12px',
    color: ' #55556D',
  },
  tableHead: {
    backgroundColor: '#F4F4F6',
    borderRadius: '4px',
  },
  button: {
    borderRadius: '8px',
    marginTop: '12px',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
  },
  inputFileWrapper: {
    width: '100%',
    border: '1px dashed #B8B8C7',
    borderRadius: '12px',
    padding: theme.spacing(3, 1),
    margin: theme.spacing(2, 0, 0, 0),
    cursor: 'pointer',
  },
  inputFileDisabled: {
    cursor: 'default',
  },
  inputFile: {
    position: 'absolute !important',
    height: 1,
    width: 1,
    overflow: 'hidden',
    clip: 'rect(1px, 1px, 1px, 1px)',
  },
  descriptionImage: {
    padding: theme.spacing(1, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadImageText: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#7B39FF',
    textAlign: 'center',
  },
  optionalText: {
    color: '#B8B8C7',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
  },
  imgCropped: {
    maxHeight: 112,
    objectFit: 'contain',
  },
  wrapperImageCropped: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeImageIcon: {
    cursor: 'pointer',
    position: 'absolute',
    top: -24,
    right: 0,
  },
  landscape: {
    maxHeight: 112,
    width: '100%',
  },
  promotionName: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#55556D',
  },
  contentList: {
    margin: theme.spacing(2, 0),
    borderRadius: '12px',
    background: colors.grey100,
  },
  headerListItems: {
    background: colors.grey200,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    alignItems: 'center',
    borderRadius: '12px 12px 0 0',
    margin: '12px 4px',
    marginTop: '16px',
    borderBottom: '1px solid #E8E8ED',
  },
  checkbox: {
    borderRadius: '8px',
  },
  deleteItems: {
    color: '#E13065',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
  },
  listItemsWrapper: {
    overflow: 'auto',
    maxHeight: '530px',
    padding: theme.spacing(0, 2),
  },
  iconDelete: {
    color: '#E54D7B',
  },
  errorRow: {
    border: 'none',
    padding: '0 0 0 4px',
    '& p': {
      padding: 0,
      margin: 0,
      color: 'red',
    },
  },
  containerSelectImage: {
    [theme.breakpoints.between('sm', 'md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  portraitWrapper: {
    cursor: 'default',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  portraitImage: {
    maxWidth: 169,
    maxHeight: 112,
  },
  landscapeImage: {
    maxWidth: '100%',
  },
  imagePrev: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  removePrevImage: {
    position: 'absolute',
    top: '-24px',
    right: 0,
  },
  removePrevImageL: {
    position: 'absolute',
    top: '-44px',
    right: 0,
  },
  tooltipContainer: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      marginRight: theme.spacing(1),
    },
  },
  textTooltip: {
    fontSize: '12px',
    fontWeight: 500,
  },
  infoTooltip: {
    backgroundColor: '#EEE5FF',
    borderRadius: '8px',
  },
}));

export default usePage<Props>(Promotion, 'Promotion');

const PERCENTAGE = 'PERCENTAGE';
const BUYANDPAY = 'BUYANDPAY';

function Promotion(props: Props) {
  const {
    promotion,
    promotions,
    fetchPromotion,
    isSaving,
    createPromotionSuccess,
    updatePromotionSuccess,
    isFetchingPromotion,
    error,
    currency,
    updatePromotion,
    createPromotion,
    productsFilter,
    categoriesFilter,
    fetchProducts,
    fetchCategoriesSearch,
    isFetchingProducts,
    isFetchingCategories,
    paginationProducts,
    paginationCategories,
    resetProductsFilter,
    resetCategoriesFilter,
    resetPromotion,
  } = props;

  console.log({promotions, promotion});

  const classes = useStyles();
  const history = useHistory();
  const {promotionId} = useParams();

  const fileInputHRef = useRef();
  const fileInputVRef = useRef();

  const [openActiveModal, setOpenActiveModal] = useState(false);
  const [openCropModal, setOpenCropModal] = useState(false);

  const cropTypeRef = useRef<'vertical' | 'horizontal' | null>(null);

  const [portraitImage, setPortraitImage] = useState(null);
  const [landscapeImage, setLandscapeImage] = useState(null);

  const [verticalFile, setVerticalFile] = useState<null | File>(null);
  const [horizontalFile, setHorizontalFile] = useState<null | File>(null);

  const [
    verticalImageResult,
    setVerticalImageResult,
  ] = useState<ImageToCrop | null>(null);

  const [
    horizontalImageResult,
    setHorizontalImageResult,
  ] = useState<ImageToCrop | null>(null);

  const {handleSubmit, watch, register, errors} = useForm({});

  const [promotionEnabled, setPromotionEnabled] = useState(true);
  const [promotionType, setPromotionType] = useState<PromotionType | ''>('');
  const [minRequirement, setMinRequirement] = useState('none');
  const [maxDiscount, setMaxDiscount] = useState('');
  const [errorSubmit, setErrorSubmit] = useState({
    promotionType: false,
    applyTo: false,
    notList: false,
    maxDiscount: false,
    minRequirement: false,
  });
  const [imagesError, setImagesError] = useState(false);

  const [applyTo, setApplyTo] = useState<
    'ALL_PRODUCTS' | 'PRODUCT' | 'PRODUCT_CATEGORY'
  >('PRODUCT');

  const [promotionScopeSelected, setPromotionScopeSelected] = useState<
    'PRODUCT' | 'SHIPPING'
  >('PRODUCT');

  const [listProductsItems, setListProductsItems] = useState([]);
  const [listCategoryItems, setListCategoryItems] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [listItems, setListItems] = useState([]);
  const [listToDelete, setListToDelete] = useState([]);

  const hasPromotionFeature = useIsFeatureInTier('STORE_PROMOTION');
  const featureSpec = useFeatureSpec('STORE_PROMOTION');

  const watchAllValues = watch();

  const shouldShowPromotionScope = useMemo(() => {
    if (promotion) return promotion.promotionScope === 'SHIPPING';

    return promotions?.every(promo => promo.promotionScope === 'PRODUCT');
  }, [promotion, promotions]);

  const shouldCreatePromotions = useMemo(() => {
    if (promotions) {
      if (featureSpec && featureSpec.limit) {
        return (
          promotions.filter(c => c.enabled).length < Number(featureSpec.limit)
        );
      }
      return true;
    } else return false;
  }, [featureSpec, promotions]);

  const currentActivePromotion = useMemo(() => {
    return (
      promotion &&
      promotions &&
      promotions.filter(p => p.enabled).find(pr => pr.id === promotion.id)
    );
  }, [promotion, promotions]);

  const handleChangeInput = (e, direction: string) => {
    e.stopPropagation();
    const files: File[] = e.target.files;
    const [file] = files;

    if (!file) return;

    if (direction === 'vertical') {
      setVerticalFile(file);
      cropTypeRef.current = direction;
    }
    if (direction === 'horizontal') {
      setHorizontalFile(file);
      cropTypeRef.current = direction;
    }
    setOpenCropModal(true);

    e.target.value = null;
  };

  const handleAddImageClick = (direction: string) => {
    if (direction === 'vertical') {
      if (fileInputVRef.current) {
        fileInputVRef.current.value = '';
        fileInputVRef.current.click();
      }
    } else if (direction === 'horizontal') {
      if (fileInputHRef.current) {
        fileInputHRef.current.value = '';
        fileInputHRef.current.click();
      }
    }
  };

  const handleCloseCropModal = () => {
    setOpenCropModal(false);
    setVerticalFile(null);
    setHorizontalFile(null);
  };

  const handleCropSubmit = (results: ImageToCrop[]) => {
    console.log({
      new: results[0].file.size,
    });
    const cropType = cropTypeRef.current;
    const [file] = results;
    if (cropType === 'vertical') {
      setVerticalImageResult(file);
    } else if (cropType === 'horizontal') {
      setHorizontalImageResult(file);
    }
    handleCloseCropModal();
  };

  const SectionAddImage = ({
    direction,
    imageResult,
  }: {
    direction: string,
    imageResult: ImageToCrop | null,
  }) => {
    return (
      <>
        <div
          className={`${classes.inputFileWrapper} ${
            imageResult ? classes.inputFileDisabled : ''
          }`}
          style={{
            paddingTop: imageResult ? '44px' : 'undefined',
          }}
          onClick={() => handleAddImageClick(direction)}
        >
          {imageResult ? (
            <div className={classes.wrapperImageCropped}>
              <img
                src={imageResult.preview}
                alt="preview cropped"
                className={`${classes.imgCropped} ${classes.landscape}`}
              />
            </div>
          ) : (
            <Grid container className={classes.containerSelectImage}>
              <Grid item xs={4} sm={6} md={4}>
                <img
                  src={addImage}
                  alt="Add preview promotion"
                  style={{height: '100%'}}
                />
              </Grid>
              <Grid item xs={8} sm={6} md={8}>
                <div className={classes.descriptionImage}>
                  <Icon color="primary">
                    <PublishRounded />
                  </Icon>
                  <Typography className={classes.uploadImageText}>
                    {direction === 'vertical'
                      ? 'Sube imagen formato 1'
                      : 'Sube imagen formato 2'}
                  </Typography>
                  <Typography className={classes.optionalText}>
                    {direction === 'vertical' ? '1100 x 560 ' : '1100 x 300'}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          )}
        </div>
        <input
          ref={direction === 'vertical' ? fileInputVRef : fileInputHRef}
          className={classes.inputFile}
          id="img-crop"
          style={!!imageResult ? {display: 'none'} : {}}
          type="file"
          onChange={e => handleChangeInput(e, direction)}
          accept="image/*"
        />
      </>
    );
  };

  useEffect(() => {
    if (!hasPromotionFeature) history.replace('/promotions');
  }, [hasPromotionFeature, history]);

  useEffect(() => {
    if (promotionId && promotionId !== 'new') fetchPromotion({promotionId});
  }, [promotionId, fetchPromotion]);

  useEffect(() => {
    if (promotion && promotion.promotionType) {
      setPromotionEnabled(promotion.enabled);
      setPromotionType(promotion.promotionType);
      if (!promotion.minAmount && !promotion.minQuantity) {
        setMinRequirement('none');
      } else if (promotion.minAmount) {
        setMinRequirement('minAmount');
      } else if (promotion.minQuantity) {
        setMinRequirement('minQuantity');
      }
      if (promotion && promotion.promotionMode) {
        const mode = promotion.promotionMode;
        let tempItems = [];
        if (
          mode !== 'CATEGORY' &&
          promotion.products &&
          promotion.products.length
        ) {
          if (mode === 'PRODUCT') {
            tempItems = promotion.products.map(({product}) => ({
              id: product.id,
              name: product.name,
              mainImageId: product.mainImage && product.mainImage.id,
            }));
          }
        } else if (promotion.productCategories) {
          tempItems = promotion.productCategories.map(({productCategory}) => ({
            id: productCategory.id,
            name: productCategory.name,
            mainImageId: productCategory.portraitImageId,
          }));
        }
        //$FlowFixMe
        setListItems(tempItems);
        setApplyTo(
          mode === 'ALL'
            ? 'ALL_PRODUCTS'
            : mode === 'PRODUCT'
            ? 'PRODUCT'
            : 'PRODUCT_CATEGORY'
        );
      }
      if (!promotion.maxAmount) {
        setMaxDiscount('none');
      } else setMaxDiscount('maxAmount');
    }
  }, [promotion]);

  useEffect(() => {
    if (promotion) {
      if (promotion.promotionSmallImageId) {
        setPortraitImage(getImageUrl(promotion.promotionSmallImageId));
      }
      if (promotion.promotionImageId) {
        setLandscapeImage(getImageUrl(promotion.promotionImageId));
      }
      if (promotion.promotionScope) {
        setPromotionScopeSelected(promotion.promotionScope);
      }
    }
  }, [promotion]);

  useEffect(() => {
    if (!Boolean(error) && updatePromotionSuccess && promotion) {
      history.push(`/marketing/promotions`);
    }
  }, [error, history, promotion, updatePromotionSuccess]);

  useEffect(() => {
    if (createPromotionSuccess) {
      history.push('/marketing/promotions/creation/success');
    }
  }, [createPromotionSuccess, history]);

  useEffect(() => {
    return () => resetPromotion();
  }, [resetPromotion]);

  const isAppliedWithItems = useMemo(
    () => ['PRODUCT', 'PRODUCT_CATEGORY'].includes(applyTo),
    [applyTo]
  );

  const completedImages =
    !!(portraitImage || verticalImageResult) &&
    !!(landscapeImage || horizontalImageResult);

  const executeSubmit = (enabled: boolean) => {
    const values = watch();
    const promotionImage = horizontalImageResult
      ? horizontalImageResult.file
      : undefined;

    const promotionSmallImage = verticalImageResult
      ? verticalImageResult.file
      : undefined;

    if (!promotion) {
      const promotionRequest: PromotionRequest = {
        enabled,
        description: values.description,
        name: values.name,
        promotionType,
        promotionImage,
        promotionSmallImage,
        enabledInteractWithOtherPromotions:
          promotionScopeSelected === 'PRODUCT'
            ? values.applyWithOtherPromotions
            : true,
        enabledOnOfferPrice:
          promotionScopeSelected === 'PRODUCT' ? values.applySalePrice : true,

        buyQuantity:
          promotionType === BUYANDPAY ? Number(values.buyQuantity) : undefined,
        payQuantity:
          promotionType === BUYANDPAY ? Number(values.payQuantity) : undefined,
        maxUses:
          promotionType === BUYANDPAY ? Number(values.maxUses) : undefined,
        discountPercentage:
          promotionType === PERCENTAGE ? values.discountValue : undefined,
        maxAmount:
          promotionType === PERCENTAGE && maxDiscount === 'maxAmount'
            ? values.maxAmount
            : undefined,
        minAmount:
          minRequirement === 'minAmount' ? values.minAmount : undefined,
        minQuantity:
          minRequirement === 'minQuantity'
            ? Number(values.minQuantity)
            : undefined,
        scope: promotionScopeSelected,
      };

      if (applyTo !== 'ALL_PRODUCTS') {
        if (applyTo === 'PRODUCT') {
          const products = listItems.map((p: Product) => ({productId: p.id}));
          promotionRequest.mode = 'PRODUCT';
          promotionRequest.products = products;
        } else if (applyTo === 'PRODUCT_CATEGORY') {
          const categories = listItems.map((c: Category) => ({
            categoryId: c.id,
          }));
          promotionRequest.mode = 'CATEGORY';
          promotionRequest.categories = categories;
        }
      } else {
        promotionRequest.mode = 'ALL';
      }
      createPromotion({promotionRequest});
    } else {
      let promotionRequest: PromotionRequest = {
        enabled,
        landscapeImage,
        portraitImage,
        promotionImage,
        promotionSmallImage,
        promotionImageId: promotion.promotionImageId,
        promotionSmallImageId: promotion.promotionSmallImageId,
        enabledOnOfferPrice: values.applySalePrice,
        enabledInteractWithOtherPromotions: values.applyWithOtherPromotions,
        promotionType,
        name: promotion.name === values.name ? undefined : values.name,
        description:
          promotion.description === values.description
            ? undefined
            : values.description,
        buyQuantity:
          promotionType === BUYANDPAY ? Number(values.buyQuantity) : undefined,
        payQuantity:
          promotionType === BUYANDPAY ? Number(values.payQuantity) : undefined,
        maxUses:
          promotionType === BUYANDPAY ? Number(values.maxUses) : undefined,
        discountPercentage:
          promotionType === PERCENTAGE ? values.discountValue : undefined,
        maxAmount:
          promotionType === PERCENTAGE && maxDiscount === 'maxAmount'
            ? values.maxAmount
            : undefined,
        minAmount:
          minRequirement === 'minAmount' ? values.minAmount : undefined,
        minQuantity:
          minRequirement === 'minQuantity'
            ? Number(values.minQuantity)
            : undefined,
        scope: promotionScopeSelected,
      };
      if (applyTo !== 'ALL_PRODUCTS') {
        if (applyTo === 'PRODUCT') {
          const products = listItems.map((p: Product) => ({productId: p.id}));
          promotionRequest.mode = 'PRODUCT';
          promotionRequest.products = products;
        } else if (applyTo === 'PRODUCT_CATEGORY') {
          const categories = listItems.map((c: Category) => ({
            categoryId: c.id,
          }));
          promotionRequest.mode = 'CATEGORY';
          promotionRequest.categories = categories;
        }
      } else {
        promotionRequest.mode = 'ALL';
      }
      promotionRequest.files = true;
      updatePromotion({promotionRequest, promotionId: promotion.id});
    }
  };

  const onSubmit = values => {
    if (!completedImages) {
      setImagesError(true);
      return;
    }
    if (!promotionType || !minRequirement || !applyTo) {
      setErrorSubmit({
        minRequirement: !Boolean(minRequirement),
        applyTo: !Boolean(applyTo),
        notList: isAppliedWithItems ? listItems.length : false,
        maxDiscount: false,
        promotionType: !Boolean(promotionType),
      });
    } else {
      if (isAppliedWithItems && !listItems.length) {
        setErrorSubmit(prev => ({
          ...prev,
          notList: true,
        }));
        return;
      }
      if (
        promotionType === PERCENTAGE &&
        !maxDiscount &&
        promotionScopeSelected === 'PRODUCT'
      ) {
        setErrorSubmit(prev => ({...prev, maxDiscount: true}));
        return;
      }

      setErrorSubmit({
        minRequirement: false,
        applyTo: false,
        notList: false,
        maxDiscount: false,
        promotionType: false,
      });

      const editCurrentActivePromotion =
        promotion && !shouldCreatePromotions && !currentActivePromotion;
      const editDisabledPromotion =
        !promotionEnabled && editCurrentActivePromotion;
      const editEnabledPromotion =
        promotionEnabled && editCurrentActivePromotion;

      if (
        shouldCreatePromotions ||
        (!shouldCreatePromotions && currentActivePromotion) ||
        editDisabledPromotion ||
        editEnabledPromotion
      ) {
        executeSubmit(promotionEnabled);
      } else {
        setOpenActiveModal(true);
      }
    }
  };

  const handleEnablePromotion = e => {
    if (!promotion) return;
    // setPromotionEnabled(e.target.checked);
    executeSubmit(e.target.checked);
  };
  const infoBriefPromotion = (
    <div>
      {watchAllValues.name && (
        <div className={classes.promotionName}>
          <span>{watchAllValues.name}</span>
        </div>
      )}

      <ul className={classes.descriptionWrapper}>
        {promotionType === PERCENTAGE && !isNaN(watchAllValues.discountValue) && (
          <li className={classes.description}>
            <span>{`${Number(
              watchAllValues.discountValue
            ).toString()}% de descuento en toda la orden`}</span>
          </li>
        )}

        {!!applyTo && (
          <li className={classes.description}>
            <span>
              {applyTo === 'ALL_PRODUCTS'
                ? 'Aplica sobre todos los productos.'
                : applyTo === 'PRODUCT'
                ? 'Aplica sobre productos seleccionados.'
                : 'Aplica sobre categorias seleccionadas.'}
            </span>
          </li>
        )}
        {watchAllValues.applySalePrice && (
          <li className={classes.description}>
            <span>Aplica sobre precios en oferta</span>
          </li>
        )}

        {minRequirement === 'minAmount' &&
          watchAllValues.minAmount &&
          currency && (
            <li className={classes.description}>
              <span>{`Monto mínimo: ${commaFormat(
                watchAllValues.minAmount,
                currency.symbol
              )}`}</span>
            </li>
          )}
        {minRequirement === 'minQuantity' && watchAllValues.minQuantity && (
          <li className={classes.description}>
            <span>{`Descuento aplicado por la compra de más de ${watchAllValues.minQuantity} productos`}</span>
          </li>
        )}
        {promotionType === BUYANDPAY && watchAllValues.maxUses && (
          <li className={classes.description}>
            <span>{`Máximo de usos por orden: ${watchAllValues.maxUses}`}</span>
          </li>
        )}
        {promotionType === PERCENTAGE &&
          maxDiscount === 'maxAmount' &&
          watchAllValues.maxAmount &&
          currency && (
            <li className={classes.description}>
              <span>{`Monto máximo: ${commaFormat(
                watchAllValues.maxAmount,
                currency.symbol
              )}`}</span>
            </li>
          )}
      </ul>

      <FormControlLabel
        control={
          <IosSwitch
            className={classes.switchContainer}
            checked={promotionEnabled}
            onClick={handleEnablePromotion}
            disabled={isSaving || !hasPromotionFeature}
          />
        }
        label={
          <div className={classes.textRequirement} style={{fontWeight: 600}}>
            {promotionEnabled ? 'Promoción activada' : 'Promoción desactivada'}
          </div>
        }
      />
    </div>
  );

  const imageCropWrapper = (
    <div className={classes.cardWrap}>
      <Typography className={classes.addImage}>Añadir una imágen</Typography>
      <Grid container>
        <Grid item xs={12}>
          {portraitImage ? (
            <div
              className={`${classes.inputFileWrapper} ${classes.portraitWrapper}`}
            >
              <div className={classes.imagePrev}>
                <IconButton
                  aria-label={'cancel'}
                  className={classes.removePrevImage}
                  onClick={() => setPortraitImage(null)}
                  disabled={isSaving}
                >
                  <CancelOutlined />
                </IconButton>
                <img
                  src={portraitImage}
                  className={classes.portraitImage}
                  alt="portrait promotion"
                />
              </div>
            </div>
          ) : (
            <SectionAddImage
              direction="vertical"
              imageResult={verticalImageResult}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          {landscapeImage ? (
            <div
              className={classes.inputFileWrapper}
              style={{
                cursor: 'default',
                paddingTop: '44px',
              }}
            >
              <div className={classes.imagePrev}>
                <IconButton
                  aria-label={'cancel'}
                  className={classes.removePrevImageL}
                  onClick={() => setLandscapeImage(null)}
                  disabled={isSaving}
                >
                  <CancelOutlined />
                </IconButton>
                <img
                  src={landscapeImage}
                  className={classes.landscapeImage}
                  alt="landscape promotion"
                />
              </div>
            </div>
          ) : (
            <SectionAddImage
              direction="horizontal"
              imageResult={horizontalImageResult}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );

  const handleAddToDeleteItem = (e, index: number) => {
    const posItem: number = listToDelete.findIndex(
      i => listItems && i.id === listItems[index].id
    );

    const newList = [...listToDelete];
    if (e.target.checked) {
      if (posItem === -1) newList.push({...listItems[index], checked: true});
    } else {
      if (posItem > -1) newList.splice(posItem, 1);
    }

    setListToDelete(newList);
  };

  const handleDeleteSelectedItems = () => {
    const newList = listItems.filter(
      el => !listToDelete.find(d => d.id === el.id)
    );
    //$FlowFixMe
    setListItems(newList);
    setListToDelete([]);
  };

  const fileToCrop: File | null =
    cropTypeRef.current === 'vertical' ? verticalFile : horizontalFile;

  const aspectRatio = cropTypeRef.current === 'vertical' ? 1.96 : 3.67;

  return (
    <div className={classes.promotionWrap}>
      {(isSaving ||
        isFetchingPromotion ||
        (!promotion && promotionId !== 'new')) && <LoadingSpinner />}
      <SnackBar
        mode="error"
        className={classes.snackBarError}
        message={error}
      />
      <Snackbar
        open={imagesError}
        autoHideDuration={4000}
        onClose={() => setImagesError(false)}
      >
        <Alert severity="info" onClose={() => setImagesError(false)}>
          Debes subir todas las imágenes.
        </Alert>
      </Snackbar>
      <Grid container alignContent="flex-start">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.gridFormulario}
        >
          {/* <div className={classes.headerWrapper}>
            <Typography className={classes.title}>
              <IconButton
                className={classes.backButton}
                onClick={() =>
                  promotion
                    ? history.push(`/marketing/promotions`)
                    : history.goBack()
                }
              >
                <ArrowBack />
              </IconButton>
              {!isFetchingPromotion
                ? promotion
                  ? 'Editar promoción'
                  : 'Crear promoción'
                : ''}
            </Typography>
          </div> */}
          <Typography className={classes.grayText}>
            Las promociones se aplican automáticamente al pedido si se cumplen
            las condiciones.
            <br /> Y también genera un url único con el detalle de la promoción.
          </Typography>

          <Hidden mdUp>
            <Collapsible startClosed={true} title="Resumen de la promoción">
              <div>{infoBriefPromotion}</div>
            </Collapsible>
          </Hidden>
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              {!isFetchingPromotion && (promotionId === 'new' || promotion) && (
                <form noValidate onSubmit={handleSubmit(onSubmit)}>
                  {shouldShowPromotionScope && (
                    <div className={classes.cardWrap}>
                      <div
                        className={`${classes.typesWrap} ${classes.containerTooltip}`}
                        style={{paddingBottom: 0}}
                      >
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography className={classes.labelText}>
                            Alcance de la promoción
                          </Typography>
                        </div>

                        <FormControlLabel
                          value={minRequirement}
                          control={
                            <Radio
                              size="small"
                              color="primary"
                              checked={promotionScopeSelected === 'PRODUCT'}
                              onChange={() => {
                                setPromotionScopeSelected('PRODUCT');
                              }}
                            />
                          }
                          label={
                            <span
                              className={
                                promotionScopeSelected === 'PRODUCT'
                                  ? classes.textRequirementSelected
                                  : classes.textRequirement
                              }
                            >
                              Productos
                            </span>
                          }
                        />

                        <FormControlLabel
                          value={minRequirement}
                          control={
                            <Radio
                              size="small"
                              color="primary"
                              checked={promotionScopeSelected === 'SHIPPING'}
                              onChange={() => {
                                setPromotionScopeSelected('SHIPPING');
                              }}
                            />
                          }
                          label={
                            <span
                              className={
                                promotionScopeSelected === 'SHIPPING'
                                  ? classes.textRequirementSelected
                                  : classes.textRequirement
                              }
                            >
                              Precios de envío
                            </span>
                          }
                        />
                      </div>
                    </div>
                  )}

                  <div className={classes.cardWrap}>
                    <div className={classes.typesWrap}>
                      <Typography className={classes.labelText}>
                        Nombre de la promoción
                      </Typography>
                      <CustomTextField
                        fullWidth
                        placeholder="Nombre"
                        name="name"
                        inputRef={register({
                          required: 'Campo obligatorio',
                        })}
                        defaultValue={promotion ? promotion.name : ''}
                        error={!!errors.name}
                        helperText={errors.name ? errors.name.message : ''}
                      />
                    </div>
                    <div className={classes.typesWrap}>
                      <Typography className={classes.labelText}>
                        Descripción de la promoción (Opcional)
                      </Typography>
                      <CustomTextField
                        multiline
                        rows={4}
                        placeholder="Coloca una descripción vendedora que te gustaría que tus clientes lean al entrar en la promoción. Ejemplo: No te puedes puedes perder esta increíble promoción 2x1 en productos seleccionados."
                        name="description"
                        defaultValue={
                          promotion && promotion.description
                            ? promotion.description
                            : ''
                        }
                        error={!!errors.description}
                        helperText={
                          errors.description ? errors.description.message : ''
                        }
                        inputRef={register({
                          maxLength: {
                            value: 100,
                            message: '(Máximo de 100 caractéres)',
                          },
                        })}
                        className={classes.textDescription}
                      />
                    </div>
                    <div className={classes.typesWrap}>
                      <Typography className={classes.labelText}>
                        Tipo de promoción
                      </Typography>
                      <CustomSelect
                        native
                        fullWidth
                        value={promotionType}
                        name="typePromotion"
                        error={!!errors.promotionType}
                        helperText={
                          errors.promotionType
                            ? errors.promotionType.message
                            : ''
                        }
                        onChange={e => setPromotionType(e.target.value)}
                        disabled={isSaving}
                      >
                        <option value="" hidden />

                        {promotionScopeSelected === 'PRODUCT' && (
                          <option value="BUYANDPAY">
                            Compra “x” lleva “y”
                          </option>
                        )}

                        <option value="PERCENTAGE">Porcentaje</option>
                      </CustomSelect>
                      {errorSubmit.promotionType && !promotionType ? (
                        <span className={classes.textError}>
                          Debe seleccionar un tipo de cupón
                        </span>
                      ) : null}
                    </div>

                    {promotionType === BUYANDPAY && (
                      <div className={classes.typesWrap}>
                        <Grid container spacing={4}>
                          <Grid item xs={6}>
                            <Grid
                              container
                              spacing={2}
                              className={classes.gridBuyBring}
                            >
                              <Grid item xs={12} md={4}>
                                <Typography className={classes.textInput}>
                                  Compra:
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={8}>
                                <CustomTextField
                                  name="buyQuantity"
                                  type="number"
                                  inputRef={register({
                                    required: 'Campo obligatorio',
                                    pattern: {
                                      value: /^[1-9]\d*$/,
                                      message: 'Formato de número inválido',
                                    },
                                  })}
                                  defaultValue={
                                    promotion &&
                                    typeof promotion.buyQuantity === 'number'
                                      ? promotion.buyQuantity
                                      : ''
                                  }
                                  error={!!errors.buyQuantity}
                                />
                              </Grid>
                              {errors && errors.buyQuantity && (
                                <Typography
                                  color="error"
                                  style={{fontSize: '12px'}}
                                >
                                  {errors.buyQuantity.message}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                          <Grid item xs={6}>
                            <Grid
                              container
                              spacing={2}
                              className={classes.gridBuyBring}
                            >
                              <Grid item xs={12} md={4}>
                                <Typography className={classes.textInput}>
                                  Paga:
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={8}>
                                <CustomTextField
                                  name="payQuantity"
                                  type="number"
                                  inputRef={register({
                                    required: 'Campo obligatorio',
                                    max: {
                                      value:
                                        Number(watchAllValues.buyQuantity) - 1,
                                      message: 'Cantidad incorrecta',
                                    },
                                    pattern: {
                                      value: /^[1-9]?[1-9]+/,
                                      message: 'Formato de número inválido',
                                    },
                                    // validate: value =>
                                    //   (Number(value) <
                                    //     Number(watchAllValues.buyQuantity) &&
                                    //     Number(value) > 0) ||
                                    //   'Cantidad incorrecta.',
                                  })}
                                  defaultValue={
                                    promotion &&
                                    typeof promotion.payQuantity === 'number'
                                      ? promotion.payQuantity
                                      : ''
                                  }
                                  error={!!errors.payQuantity}
                                />
                              </Grid>
                              {errors && errors.payQuantity && (
                                <Typography
                                  color="error"
                                  style={{fontSize: '12px'}}
                                >
                                  {errors.payQuantity.message}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>

                          <Grid item xs={12}>
                            <Typography className={classes.descriptionSmall}>
                              El cliente deberá pagar el o los productos de
                              mayor precio.
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    )}
                    {promotionType === PERCENTAGE && (
                      <div className={classes.typesWrap}>
                        <Typography className={classes.labelText}>
                          Valor de descuento
                        </Typography>
                        <CustomTextField
                          placeholder=""
                          fullWidth
                          name="discountValue"
                          defaultValue={
                            promotion && promotion.discountPercentage
                              ? Number(promotion.discountPercentage).toFixed(0)
                              : ''
                          }
                          inputRef={register({
                            required: 'Campo obligatorio',
                            pattern: {
                              value: /^[1-9][0-9]?$|^100$/,
                              message: 'Ingresar un numero entre 1 y 100',
                            },
                          })}
                          InputProps={{
                            // readOnly:
                            //   coupon &&
                            //   (!coupon.enabled || coupon.usageCount > 0),
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                style={{
                                  marginTop: '0',
                                  position: 'absolute',
                                  marginLeft: '94%',
                                }}
                              >
                                %
                              </InputAdornment>
                            ),
                          }}
                          error={!!errors.discountValue}
                          helperText={
                            errors.discountValue
                              ? errors.discountValue.message
                              : ''
                          }
                        />
                      </div>
                    )}

                    {promotionScopeSelected === 'PRODUCT' && (
                      <>
                        <div style={{marginTop: '16px'}}>
                          <FormControlLabel
                            control={
                              <IosSwitch
                                className={classes.switch}
                                name="applySalePrice"
                                defaultChecked={
                                  promotion
                                    ? promotion.enabledOnOfferPrice
                                    : false
                                }
                                color="primary"
                                disabled={!promotionType}
                                inputRef={register()}
                              />
                            }
                            label={
                              <div className={classes.labelSwitch}>
                                <span className={classes.switchTitle}>
                                  ¿Aplica sobre precios de oferta o precios al
                                  por mayor?
                                </span>
                                <br />
                                <span className={classes.switchBody}>
                                  Si activas esta opción quiere decir que se
                                  considerarán los precios de oferta o al por
                                  mayor para efectuar la promoción y si no lo
                                  tiene el precio regular.
                                </span>
                              </div>
                            }
                          />
                        </div>
                        <div style={{marginTop: '16px'}}>
                          <FormControlLabel
                            control={
                              <IosSwitch
                                className={classes.switch}
                                name="applyWithOtherPromotions"
                                defaultChecked={
                                  promotion
                                    ? promotion.enabledInteractWithOtherPromotions
                                    : false
                                }
                                color="primary"
                                disabled={!promotionType}
                                inputRef={register()}
                              />
                            }
                            label={
                              <div className={classes.labelSwitch}>
                                <span className={classes.switchTitle}>
                                  ¿Se puede aplicar en conjunto con otras
                                  promociones?
                                </span>
                                <br />
                                <span className={classes.switchBody}>
                                  Esta opción permite que se aplique esta
                                  promoción en conjunto con otra.
                                </span>
                              </div>
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div className={classes.cardWrap}>
                    <div
                      className={`${classes.typesWrap} ${classes.containerTooltip}`}
                      style={{paddingBottom: 0}}
                    >
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Typography className={classes.labelText}>
                          Aplica a
                        </Typography>
                      </div>

                      <FormControlLabel
                        value={minRequirement}
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            checked={applyTo === 'PRODUCT'}
                            onChange={() => {
                              setApplyTo('PRODUCT');
                              setListCategoryItems(listItems);
                              setListItems(listProductsItems);
                            }}
                          />
                        }
                        label={
                          <span
                            className={`${
                              applyTo === 'PRODUCT'
                                ? classes.textRequirementSelected
                                : classes.textRequirement
                            }`}
                          >
                            Productos específicos
                          </span>
                        }
                      />

                      <FormControlLabel
                        value={minRequirement}
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            checked={applyTo === 'PRODUCT_CATEGORY'}
                            onChange={() => {
                              setApplyTo('PRODUCT_CATEGORY');
                              setListProductsItems(listItems);
                              setListItems(listCategoryItems);
                            }}
                          />
                        }
                        label={
                          <span
                            className={`${
                              applyTo === 'PRODUCT_CATEGORY'
                                ? classes.textRequirementSelected
                                : classes.textRequirement
                            }`}
                          >
                            Categorías específicas
                          </span>
                        }
                      />
                      {errorSubmit.applyTo && !applyTo ? (
                        <span className={classes.textError}>
                          Debe seleccionar el criterio donde aplica tu
                          promoción.
                        </span>
                      ) : null}
                      {errorSubmit.notList &&
                      isAppliedWithItems &&
                      !listItems.length ? (
                        <span className={classes.textError}>
                          Debe seleccionar al menos 1{' '}
                          {applyTo === 'PRODUCT' ? 'producto.' : 'categoría.'}
                        </span>
                      ) : null}
                      {isAppliedWithItems && (
                        <CustomButton
                          fullWidth
                          variant="outlined"
                          color="primary"
                          size="large"
                          className={classes.button}
                          onClick={() => setOpenModal(true)}
                        >
                          {`${
                            listItems.length > 0
                              ? 'Agregar más '
                              : 'Seleccionar '
                          } ${
                            applyTo === 'PRODUCT' ? 'productos' : 'categorías'
                          }`}
                        </CustomButton>
                      )}

                      {listItems.length > 0 && isAppliedWithItems && (
                        <div className={classes.contentList}>
                          <div className={classes.headerListItems}>
                            <FormControlLabel
                              classes={{label: classes.item}}
                              className={classes.option}
                              control={
                                <Checkbox
                                  color="primary"
                                  className={classes.checkbox}
                                  checked={
                                    listToDelete.length === listItems.length
                                  }
                                  onChange={e => {
                                    const isChecked = e.target.checked;
                                    if (isChecked) {
                                      setListToDelete(listItems);
                                    } else setListToDelete([]);
                                  }}
                                />
                              }
                              label={`${
                                applyTo === 'PRODUCT'
                                  ? 'Productos'
                                  : 'Categorías'
                              } (${listToDelete.length})`}
                            />
                            {listToDelete.length !== 0 && (
                              <CustomButton
                                className={classes.deleteItems}
                                onClick={handleDeleteSelectedItems}
                              >
                                Eliminar seleccionados
                              </CustomButton>
                            )}
                          </div>
                          <Grid
                            container
                            spacing={2}
                            className={classes.listItemsWrapper}
                          >
                            {listItems.map((p, index: number) => (
                              <Grid
                                container
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                key={index}
                                className={classes.item}
                              >
                                <div
                                  key={index}
                                  className={classes.wrapperItem}
                                >
                                  <FormControlLabel
                                    classes={{label: classes.item}}
                                    className={classes.option}
                                    control={
                                      <Checkbox
                                        color="primary"
                                        className={classes.checkbox}
                                        checked={
                                          !!listToDelete.find(
                                            l => l.id === p.id
                                          )
                                        }
                                        onChange={e =>
                                          handleAddToDeleteItem(e, index)
                                        }
                                      />
                                    }
                                    label={
                                      <div className={classes.item}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <img
                                            className={classes.imageItem}
                                            alt={p.name}
                                            src={getImageUrl(
                                              p.mainImageId || p.portraitImageId
                                            )}
                                            width="56"
                                            height="56"
                                          />

                                          <div className={classes.nameProduct}>
                                            {p.name}
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  />
                                </div>
                              </Grid>
                            ))}
                          </Grid>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={classes.cardWrap}>
                    <div
                      className={classes.typesWrap}
                      style={{paddingBottom: 0}}
                    >
                      <Typography className={classes.labelText}>
                        Requerimiento Mínimo
                      </Typography>

                      <FormControlLabel
                        value={minRequirement}
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            checked={minRequirement === 'none'}
                            onChange={() => setMinRequirement('none')}
                          />
                        }
                        label={
                          <span
                            className={`${
                              minRequirement === 'none'
                                ? classes.textRequirementSelected
                                : classes.textRequirement
                            }`}
                          >
                            Ninguno
                          </span>
                        }
                      />

                      <FormControlLabel
                        value={minRequirement}
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            checked={minRequirement === 'minAmount'}
                            onChange={() => setMinRequirement('minAmount')}
                          />
                        }
                        label={
                          <span
                            className={`${
                              minRequirement === 'minAmount'
                                ? classes.textRequirementSelected
                                : classes.textRequirement
                            }`}
                          >
                            {`Compra mínima de (${(currency &&
                              currency.symbol) ||
                              ''})`}
                          </span>
                        }
                      />
                      {minRequirement === 'minAmount' && currency && (
                        <CustomTextField
                          placeholder={currency.symbol}
                          fullWidth
                          type="number"
                          name="minAmount"
                          inputRef={register({
                            required: 'Campo obligatorio',
                            pattern: {
                              value: /^[0-9]+([.][0-9]+)?$/i,
                              message: 'Formato de número inválido',
                            },
                            min: {
                              value: 0,
                              message: 'Monto no puede ser menor a 0',
                            },
                          })}
                          defaultValue={
                            promotion && promotion.minAmount
                              ? Number(promotion.minAmount)
                              : ''
                          }
                          error={!!errors.minAmount}
                          helperText={
                            errors.minAmount ? errors.minAmount.message : ''
                          }
                        />
                      )}
                      <div style={{display: 'flex'}}>
                        <FormControlLabel
                          value={minRequirement}
                          control={
                            <Radio
                              size="small"
                              color="primary"
                              checked={minRequirement === 'minQuantity'}
                              onChange={() => setMinRequirement('minQuantity')}
                            />
                          }
                          label={
                            <span
                              className={`${
                                minRequirement === 'minQuantity'
                                  ? classes.textRequirementSelected
                                  : classes.textRequirement
                              }`}
                            >
                              Cantidad mínima de productos
                            </span>
                          }
                        />
                      </div>
                      {minRequirement === 'minQuantity' && (
                        <CustomTextField
                          fullWidth
                          name="minQuantity"
                          inputRef={register({
                            required: 'Campo obligatorio',
                            pattern: {
                              value: /^[0-9]*$/i,
                              message: 'Formato de número inválido',
                            },
                            min: {
                              value: 1,
                              message:
                                'Cantidad de productos no puede ser menor a 0',
                            },
                          })}
                          defaultValue={
                            promotion && promotion.minQuantity
                              ? Number(promotion.minQuantity)
                              : ''
                          }
                          error={!!errors.minQuantity}
                          helperText={
                            errors.minQuantity ? errors.minQuantity.message : ''
                          }
                        />
                      )}
                      {errorSubmit.minRequirement && !minRequirement ? (
                        <span className={classes.textError}>
                          Debe seleccionar un requerimiento mínimo
                        </span>
                      ) : null}
                    </div>
                  </div>
                  {promotionType && promotionType === BUYANDPAY && (
                    <div className={classes.cardWrap}>
                      <div
                        className={classes.typesWrap}
                        style={{paddingBottom: 0}}
                      >
                        <Typography className={classes.labelText}>
                          Máximo de usos por orden
                        </Typography>
                        <CustomTextField
                          fullWidth
                          placeholder="Cantidad"
                          name="maxUses"
                          inputRef={register({
                            required: 'Campo obligatorio',
                            pattern: {
                              value: /^[0-9]\d*$/,
                              message: 'Formato de número inválido',
                            },
                          })}
                          defaultValue={promotion ? promotion.maxUses : ''}
                          error={!!errors.maxUses}
                          helperText={
                            errors.maxUses ? errors.maxUses.message : ''
                          }
                        />
                        <div style={{marginTop: '1rem'}}>
                          <Typography className={classes.descriptionSmall}>
                            Cuántas promociones como máximo se podrá aplicar a
                            una misma compra.
                          </Typography>
                        </div>
                      </div>
                    </div>
                  )}

                  {promotionType &&
                    promotionType === PERCENTAGE &&
                    promotionScopeSelected === 'PRODUCT' && (
                      <div className={classes.cardWrap}>
                        <div
                          className={classes.typesWrap}
                          style={{paddingBottom: 0}}
                        >
                          <Typography className={classes.labelText}>
                            Monto máximo de descuento por orden
                          </Typography>

                          <FormControlLabel
                            control={
                              <Radio
                                size="small"
                                color="primary"
                                checked={maxDiscount === 'none'}
                                onChange={() => setMaxDiscount('none')}
                              />
                            }
                            label={
                              <span
                                className={`${
                                  maxDiscount === 'none'
                                    ? classes.textRequirementSelected
                                    : classes.textRequirement
                                }`}
                              >
                                Ninguno
                              </span>
                            }
                          />

                          <FormControlLabel
                            control={
                              <Radio
                                size="small"
                                color="primary"
                                checked={maxDiscount === 'maxAmount'}
                                onChange={() => setMaxDiscount('maxAmount')}
                              />
                            }
                            label={
                              <span
                                className={`${
                                  maxDiscount === 'maxAmount'
                                    ? classes.textRequirementSelected
                                    : classes.textRequirement
                                }`}
                              >
                                {`Monto (${(currency && currency.symbol) ||
                                  ''})`}
                              </span>
                            }
                          />
                          {errorSubmit.maxDiscount && !maxDiscount ? (
                            <span className={classes.textError}>
                              Debe seleccionar un monto máximo.
                            </span>
                          ) : null}
                          {maxDiscount === 'maxAmount' && currency && (
                            <CustomTextField
                              placeholder={currency.symbol}
                              fullWidth
                              type="number"
                              name="maxAmount"
                              inputRef={register({
                                required: 'Campo obligatorio',
                                pattern: {
                                  value: /^[0-9]+([.][0-9]+)?$/i,
                                  message: 'Formato de número inválido',
                                },
                                min: {
                                  value: 0,
                                  message: 'Monto no puede ser menor a 0',
                                },
                              })}
                              defaultValue={
                                promotion && promotion.maxAmount
                                  ? promotion.maxAmount
                                  : ''
                              }
                              error={!!errors.maxAmount}
                              helperText={
                                errors.maxAmount ? errors.maxAmount.message : ''
                              }
                            />
                          )}
                        </div>
                      </div>
                    )}

                  <Hidden mdUp>
                    {imageCropWrapper}
                    {hasPromotionFeature && (
                      <div className={classes.containerSaveButton}>
                        <div className={classes.cardSaveButton}>
                          <CustomButton
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="large"
                            className={classes.saveButton}
                            disabled={isSaving}
                          >
                            {promotion ? 'Guardar cambios' : 'Crear promoción'}
                          </CustomButton>
                          <FormControlLabel
                            control={
                              <IosSwitch
                                className={classes.switchContainer}
                                checked={promotionEnabled}
                                onChange={handleEnablePromotion}
                                disabled={!hasPromotionFeature}
                              />
                            }
                            label={
                              <div
                                className={classes.textRequirement}
                                style={{fontWeight: 600}}
                              >
                                {promotionEnabled
                                  ? 'Promoción activada'
                                  : 'Promoción desactivada'}
                              </div>
                            }
                          />
                        </div>
                      </div>
                    )}
                  </Hidden>
                </form>
              )}
            </Grid>
            <Hidden smDown>
              <Grid item xs={12} md={5}>
                <Grid container>
                  <Grid item xs={12}>
                    <div className={classes.cardWrap}>
                      <div>
                        <Typography
                          className={classes.labelText}
                          style={{padding: 0, margin: 0}}
                        >
                          Resumen de la promoción
                        </Typography>
                        <hr className={classes.divider} />
                        {infoBriefPromotion}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    {imageCropWrapper}
                  </Grid>
                  {hasPromotionFeature && (
                    <Hidden smDown>
                      <div
                        className={classes.cardWrap}
                        style={{padding: '16px', width: '100%'}}
                      >
                        <CustomButton
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classes.saveButton}
                          onClick={handleSubmit(onSubmit)}
                          disabled={!hasPromotionFeature || isSaving}
                          style={{margin: 0}}
                        >
                          {promotion ? 'Guardar cambios' : 'Crear promoción'}
                        </CustomButton>
                      </div>
                    </Hidden>
                  )}
                </Grid>
              </Grid>
            </Hidden>
          </Grid>
          {/* )} */}
        </Grid>

        <ModalSelectItems
          title={
            applyTo === 'PRODUCT' ? 'Agregar productos' : 'Agregar categorías'
          }
          open={openModal}
          handleClose={() => setOpenModal(false)}
          items={applyTo === 'PRODUCT' ? productsFilter : categoriesFilter}
          type={applyTo === 'PRODUCT' ? 'PRODUCT' : 'PRODUCT_CATEGORY'}
          pagination={
            applyTo === 'PRODUCT' ? paginationProducts : paginationCategories
          }
          isFetchingItems={
            applyTo === 'PRODUCT' ? isFetchingProducts : isFetchingCategories
          }
          fetchCategories={fetchCategoriesSearch}
          fetchProducts={fetchProducts}
          setListItems={value => {
            setListItems(value);
            if (applyTo === 'PRODUCT') setListProductsItems(value);
            else setListCategoryItems(value);
          }}
          listItems={listItems}
          resetListFilter={
            applyTo === 'PRODUCT' ? resetProductsFilter : resetCategoriesFilter
          }
        />
        <AlertActivePromotion
          showOnlyCreate={!promotion}
          openModal={openActiveModal}
          handleConfirm={() => executeSubmit(true)}
          handleOnlyCreate={() => {
            setPromotionEnabled(false);
            executeSubmit(false);
          }}
          handleCloseModal={() => setOpenActiveModal(false)}
        />
      </Grid>

      {fileToCrop && cropTypeRef.current && (
        <CropModal
          open={openCropModal}
          onClose={handleCloseCropModal}
          onSubmit={handleCropSubmit}
          compressOptions={{
            quality: 1,
            maxWidth: 1100,
            maxHeight: 1100 / aspectRatio,
          }}
          images={[
            {
              file: fileToCrop,
              preview: URL.createObjectURL(fileToCrop),
            },
          ]}
          aspect={aspectRatio}
        />
      )}
    </div>
  );
}

Promotion.propTypes = {
  isSaving: PropTypes.bool,
  createPromotionSuccess: PropTypes.bool,
  updatePromotionSuccess: PropTypes.bool,
  error: PropTypes.string,
  promotion: PropTypes.object,
  fetchPromotion: PropTypes.func.isRequired,
  updatePromotion: PropTypes.func.isRequired,
  isFetchingPromotion: PropTypes.bool,
  createPromotion: PropTypes.func,
  currency: PropTypes.object,
  fetchProducts: PropTypes.func,
  fetchCategoriesSearch: PropTypes.func,
  isFetchingProducts: PropTypes.bool,
  isFetchingCategories: PropTypes.bool,
  paginationProducts: PropTypes.object,
  paginationCategories: PropTypes.object,
  resetProductsFilter: PropTypes.func,
  resetCategoriesFilter: PropTypes.func,
  resetPromotion: PropTypes.func.isRequired,
  promotions: PropTypes.array,
};
